var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light",
      class: { "m-quick-sidebar--on": _vm.detailOffer },
      attrs: { id: "m_quick_sidebar" }
    },
    [
      _vm.detailOffer
        ? _c("div", { staticClass: "m-quick-sidebar__content" }, [
            _c("div", { staticClass: "tab-header" }, [
              _c("h3", [
                _vm.detailOffer.firma != ""
                  ? _c("span", [_vm._v(_vm._s(_vm.detailOffer.firma))])
                  : _c("span", [_vm._v(_vm._s(_vm.detailOffer.name))]),
                _vm._v(" - " + _vm._s(_vm.detailOffer.name))
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "m-quick-sidebar__close",
                attrs: { id: "m_quick_sidebar_close" },
                on: {
                  click: function($event) {
                    return _vm.closeDetail()
                  }
                }
              },
              [_c("i", { staticClass: "la la-close" })]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "tab-content" }, [
              _c(
                "div",
                {
                  staticClass: "tab-pane active",
                  attrs: {
                    id: "m_quick_sidebar_tabs_messenger",
                    role: "tabpanel"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "m-messenger m-messenger--message-arrow m-messenger--skin-light"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "m-messenger__messages m-scrollable m-scroller ps ps--active-y"
                        },
                        _vm._l(_vm.detailOffer.updates, function(update) {
                          return _c(
                            "div",
                            { staticClass: "m-messenger__wrapper" },
                            [
                              update.type == "Kunden Feedback"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-messenger__message m-messenger__message--out"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-messenger__message-body"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "m-messenger__message-arrow"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-messenger__message-content"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-messenger__message-username"
                                                },
                                                [
                                                  update.user !=
                                                    update.for_user &&
                                                  update.for_user != "-"
                                                    ? _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.for_user
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " von " +
                                                            _vm._s(
                                                              update.user
                                                            ) +
                                                            " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.user
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            )
                                                        )
                                                      ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "m-messenger__message-text",
                                                domProps: {
                                                  innerHTML: _vm._s(update.text)
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : update.type == "Projekt Information"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-messenger__message m-messenger__message--warning"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-messenger__message-pic"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "img/user-" +
                                                update.user +
                                                ".jpg",
                                              alt: ""
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-messenger__message-body"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "m-messenger__message-arrow"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-messenger__message-content"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-messenger__message-username"
                                                },
                                                [
                                                  update.user !=
                                                    update.for_user &&
                                                  update.for_user != "-"
                                                    ? _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.for_user
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " von " +
                                                            _vm._s(
                                                              update.user
                                                            ) +
                                                            " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.user
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            )
                                                        )
                                                      ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "m-messenger__message-text",
                                                domProps: {
                                                  innerHTML: _vm._s(update.text)
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-messenger__message m-messenger__message--in"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-messenger__message-pic"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "img/user-" +
                                                update.user +
                                                ".jpg",
                                              alt: ""
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-messenger__message-body"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "m-messenger__message-arrow"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-messenger__message-content"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "m-messenger__message-username"
                                                },
                                                [
                                                  update.user !=
                                                    update.for_user &&
                                                  update.for_user != "-"
                                                    ? _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.for_user
                                                              ) +
                                                              " für den " +
                                                              _vm._s(
                                                                update.reminder
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " von " +
                                                            _vm._s(
                                                              update.user
                                                            ) +
                                                            " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              update.type
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                update.user
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " am " +
                                                            _vm._s(
                                                              update.created_at
                                                            ) +
                                                            " für den " +
                                                            _vm._s(
                                                              update.reminder
                                                            )
                                                        )
                                                      ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "m-messenger__message-text",
                                                domProps: {
                                                  innerHTML: _vm._s(update.text)
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "m-messenger__datetime",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-messenger__seperator" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-messenger__form d-block" }, [
                        _c(
                          "div",
                          { staticClass: "m-messenger__form-controls d-block" },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-12 col-form-label",
                                    attrs: { for: "example-date-input" }
                                  },
                                  [_vm._v("Typ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reminderType,
                                        expression: "reminderType"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 form-control m-input m-input--square",
                                    attrs: { id: "timetrackArr" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.reminderType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.reminderTypeArr, function(
                                    type,
                                    key
                                  ) {
                                    return _c(
                                      "option",
                                      { domProps: { value: key } },
                                      [_vm._v(_vm._s(type))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.reminderType == 1 || _vm.reminderType == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-group m-form__group row"
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "col-12 col-form-label",
                                        attrs: { for: "example-date-input" }
                                      },
                                      [_vm._v("Reminder für")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.reminderManagerId,
                                            expression: "reminderManagerId"
                                          }
                                        ],
                                        staticClass:
                                          "col-12 form-control m-input m-input--square",
                                        attrs: { id: "usersArr" },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.reminderManagerId = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          }
                                        }
                                      },
                                      _vm._l(_vm.managers, function(manager) {
                                        return _c(
                                          "option",
                                          { domProps: { value: manager.id } },
                                          [_vm._v(_vm._s(manager.name))]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.reminderType == 1 || _vm.reminderType == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-group m-form__group row"
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "col-12 col-form-label",
                                        attrs: { for: "example-date-input" }
                                      },
                                      [_vm._v("Reminder")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.reminderDate,
                                          expression: "reminderDate"
                                        }
                                      ],
                                      staticClass:
                                        "form-control m-input col-12",
                                      attrs: {
                                        type: "date",
                                        id: "example-date-input"
                                      },
                                      domProps: { value: _vm.reminderDate },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.reminderDate = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-12",
                                    attrs: { for: "note" }
                                  },
                                  [_vm._v("Nachricht")]
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reminderText,
                                      expression: "reminderText"
                                    }
                                  ],
                                  staticClass: "col-12 form-control m-input",
                                  attrs: { id: "note", rows: "3" },
                                  domProps: { value: _vm.reminderText },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.reminderText = $event.target.value
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-brand",
                                    on: {
                                      click: function($event) {
                                        return _vm.saveReminder()
                                      }
                                    }
                                  },
                                  [_vm._v("Speichern")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane",
                  attrs: {
                    id: "m_quick_sidebar_tabs_settings",
                    role: "tabpanel"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-list-settings m-scrollable m-scroller ps",
                      staticStyle: { height: "968px", overflow: "hidden" }
                    },
                    [
                      _c("div", { staticClass: "m-list-settings__group" }, [
                        _c(
                          "div",
                          { staticClass: "m-list-settings__heading mb-1" },
                          [_vm._v("Kunde")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "m-list-settings__item p-0" },
                          [
                            _c(
                              "div",
                              { staticClass: "m-card-user m-card-user--sm" },
                              [
                                _c("div", { staticClass: "m-card-user__pic" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-card-user__no-photo m--bg-fill-success",
                                      class:
                                        "m-badge--client-class-" +
                                        _vm.detailOffer.classId
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.detailOffer.className)
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "m-card-user__details" },
                                  [
                                    _vm.detailOffer.firma != ""
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "m-card-user__name m--font-primary",
                                            staticStyle: {
                                              "max-width": "350px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.detailOffer.firma)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "m-card-user__name",
                                        staticStyle: { "max-width": "350px" }
                                      },
                                      [_vm._v(_vm._s(_vm.detailOffer.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "m-card-user__name",
                                        staticStyle: { "max-width": "350px" }
                                      },
                                      [
                                        _c("small", [
                                          _c("i", { staticClass: "fa fa-at" }),
                                          _vm._v(
                                            " " + _vm._s(_vm.detailOffer.email)
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.detailOffer.telefon != ""
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "m-card-user__name",
                                            staticStyle: {
                                              "white-space": "nowrap"
                                            }
                                          },
                                          [
                                            _c("small", [
                                              _c("i", {
                                                staticClass: "fa fa-phone"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.detailOffer.telefon
                                                  )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.detailOffer.client_id != 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "m-card-user__name",
                                            staticStyle: {
                                              "white-space": "nowrap"
                                            }
                                          },
                                          [
                                            _c("small", [
                                              _c("i", {
                                                staticClass: "fa fa-user"
                                              }),
                                              _vm._v(
                                                " Kundennummer: " +
                                                  _vm._s(
                                                    _vm.detailOffer.client_id
                                                  )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm.detailOffer.client_id != 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "m-card-user__name",
                                            staticStyle: {
                                              "white-space": "nowrap"
                                            }
                                          },
                                          [_vm._m(1)]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "m-list-settings__heading mt-5 mb-1" },
                          [_vm._v("Anfrage")]
                        ),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c("th", [_vm._v("Kategorie")]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.detailOffer.categoryName))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Produkttyp")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.detailOffer.produkttyp))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Produkt")]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.detailOffer.price))])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Anzahl")]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.detailOffer.anzahlCa))
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("h6", [_vm._v("Anfrage Text:")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mt-3" }, [
                          _vm._v(_vm._s(_vm.detailOffer.anfrage))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-list-settings__group" }, [
                        _c("div", { staticClass: "m-list-settings__heading" }, [
                          _vm._v("Angebot")
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [_vm._v("Kalenderwoche")]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.detailOffer.kw))])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("Geplante Arbeitsstunden")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.detailOffer.working_hours) +
                                    " Stunden"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "Preis pro " + _vm._s(_vm.detailOffer.unit)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.detailOffer.price) + "€")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Gesamtbetrag")]),
                              _vm._v(" "),
                              _c("th", [_vm._v(_vm._s(_vm.detailOffer.sum))])
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticClass: "nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand",
        attrs: { id: "m_quick_sidebar_tabs", role: "tablist" }
      },
      [
        _c("li", { staticClass: "nav-item m-tabs__item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link m-tabs__link active",
              attrs: {
                "data-toggle": "tab",
                href: "#m_quick_sidebar_tabs_messenger",
                role: "tab"
              }
            },
            [_vm._v("Nachrichten")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item m-tabs__item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link m-tabs__link",
              attrs: {
                "data-toggle": "tab",
                href: "#m_quick_sidebar_tabs_settings",
                role: "tab"
              }
            },
            [_vm._v("Anfrage")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _c("i", { staticClass: "fa fa-user" }),
      _vm._v(" NEUKUNDE")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }